/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
import "./../../../assets/scss/components/cards.scss";
import "./../../../assets/scss/components/track/trackTable.scss";
import { friendlyTimeBySecond } from '../../../utils';
import { LoadingWidget } from "../../widgets/loading";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../../types/models/store";
import { Pagination } from "../../pagination";
import useAuth from "../../../hooks/useAuth";

const TrackTable: React.FC<any> = (props) => {
    const dispatch = useDispatch();
    const { user } = useAuth() as any;
    const { selected_tracks } = useSelector((state: StoreState) => state.toolbar);

    const {
        trackSearch = {},
        setTrackSearch,
        handlePage,
        moreLoading,
        handleTrackDetail,
        onClickPlus = () => { },
        onClickEdit = () => { },
        tempoList = [],
        genreList = [],
        moodList = [],
        fileExist,
    } = props.data;
    const [audio, setAudio] = useState<any>(null);
    const [playing, setPlaying] = useState(-1);

    useEffect(() => {
        try {
            if (audio) {
                audio.addEventListener('ended', () => setPlaying(-1));
                return () => {
                    audio.removeEventListener('ended', () => setPlaying(-1));
                };
            }
        } catch (e) {
            console.log(e);
        }
    }, [audio, audio?.ended]);

    return (
        <>
            <div className="track-table table-card">
                <table className="table-view w-100">
                    <thead>
                        <tr>
                            <th>
                                <span
                                    className="focus"
                                    onClick={() => {
                                        let chk = trackSearch.checked ? 0 : 1;
                                        let list = trackSearch.list;
                                        for (let i = 0; i < list.length; i++)
                                            list[i].checked = chk;
                                        setTrackSearch({ ...trackSearch, checked: chk, list: list });

                                        let ids = [];
                                        for (var j = 0; j < list.length; j++) {
                                            if (chk && list[j].file_info.id)
                                                ids.push({
                                                    id: list[j].id,
                                                    title: list[j].title,
                                                    cover: `https://img.cugate.com/?i=${list[j].album_info?.id}&o=album`,
                                                    singer: list[j].members.length ? list[j].members[0].name : '',
                                                    file: list[j].file_info?.id,
                                                });
                                        }
                                        for (let i = 0; i < selected_tracks.length; i++) {
                                            if (!list.filter((d: any) => d.id === selected_tracks[i].id).length) ids.push(selected_tracks[i]);
                                        }
                                        dispatch({
                                            type: "SET_SELECTED_TRACKS",
                                            payload: ids
                                        });
                                    }}
                                >
                                    <img className="chk" src={`/imgs/checkbox-${trackSearch.checked ? "" : "un"}checked-all.svg`} alt="" />
                                </span>
                            </th>
                            <th>
                                <span>Track Title</span>
                            </th>
                            <th>
                                <span>Album</span>
                            </th>
                            <th>
                                <span>Artists</span>
                            </th>
                            <th>
                                <span>Composer</span>
                            </th>
                            <th>
                                <span>Time</span>
                            </th>
                            <th>
                                <span>Tempo</span>
                            </th>
                            <th>
                                <span>Genre</span>
                            </th>
                            <th>
                                <span>Mood</span>
                            </th>
                            <th>
                                <span>Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {moreLoading ? (
                            <tr>
                                <td colSpan={10}>
                                    <LoadingWidget />
                                </td>
                            </tr>
                        ) : (
                            <>
                                {trackSearch.list?.map((item: any, index: number) => (
                                    <tr key={index}>
                                        <td style={{ width: '64px' }}>
                                            <div
                                                className="cell-content focus tw-flex tw-justify-center"
                                                onClick={() => {
                                                    let list = trackSearch.list;
                                                    list[index].checked = list[index].checked ? 0 : 1;
                                                    setTrackSearch({ ...trackSearch, list: list });

                                                    let ids = [];
                                                    for (var j = 0; j < list.length; j++) {
                                                        if (list[j].checked && list[j].file_info.id)
                                                            ids.push({
                                                                id: list[j].id,
                                                                title: list[j].title,
                                                                cover: `https://img.cugate.com/?i=${list[j].album_info?.id}&o=album`,
                                                                singer: list[j].members.length ? list[j].members[0].name : '',
                                                                file: list[j].file_info?.id,
                                                            });
                                                    }
                                                    for (var i = 0; i < selected_tracks.length; i++) {
                                                        if (!list.filter((d: any) => d.id === selected_tracks[i].id).length) ids.push(selected_tracks[i]);
                                                    }
                                                    dispatch({
                                                        type: "SET_SELECTED_TRACKS",
                                                        payload: ids
                                                    });
                                                }}
                                            >
                                                <img className="chk" src={`/imgs/checkbox-${item.checked ? "" : "un"}checked.svg`} width={'20px'} height={'20px'} alt="" />
                                            </div>
                                        </td>
                                        <td style={{ minWidth: '200px' }}>
                                            <div className="cell-content">{item.title}</div>
                                        </td>
                                        <td style={{ minWidth: '150px' }}>
                                            <div className="cell-content">{item.album_info?.title}</div>
                                        </td>
                                        <td style={{ minWidth: '150px' }}>
                                            <div className="cell-content">
                                                {item.members?.map((member: any, mindex: number) => member.role !== "Composer" && (
                                                    <span
                                                        className="focus"
                                                        onClick={() => window.open(`https://www.cumarket.net/artist/${member.id}i${item.album_info.id}`)}
                                                        key={mindex}
                                                    >
                                                        {item.members.filter((mm: any) => mm.role !== "Composer").length > 1 && mindex && (" , ")}
                                                        {member.name}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td style={{ minWidth: '100px' }}>
                                            <div className="cell-content">
                                                {item.members?.map((member: any, mindex: number) => member.role === "Composer" && (
                                                    <span
                                                        className="focus"
                                                        onClick={() => window.open(`https://www.cumarket.net/artist/${member.id}i${item.album_info.id}`)}
                                                        key={mindex}
                                                    >
                                                        {item.members.filter((mm: any) => mm.role === "Composer").length > 1 && mindex && (" , ")}
                                                        {member.name}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td style={{ width: '80px' }}>
                                            <div className="cell-content">{item.file_info?.track_time ? friendlyTimeBySecond(item.file_info?.track_time / 1000) : ""}</div>
                                        </td>
                                        <td style={{ minWidth: '180px' }}>
                                            <div className="cell-content">
                                                {tempoList.filter(
                                                    (g: any) => g.id === item.tempo_id
                                                ).length > 0 && (
                                                        tempoList.filter(
                                                            (g: any) => g.id === item.tempo_id
                                                        )[0]?.title
                                                    )}
                                            </div>
                                        </td>
                                        <td style={{ minWidth: '90px' }}>
                                            <div className="cell-content">
                                                {genreList.filter(
                                                    (g: any) => g.id === item.genre_id
                                                ).length > 0 && (
                                                        <div className="">
                                                            {
                                                                genreList.filter(
                                                                    (g: any) => g.id === item.genre_id
                                                                )[0]?.title
                                                            }
                                                        </div>
                                                    )}
                                                {genreList.filter(
                                                    (g: any) => g.id === item.subgenre_id
                                                ).length > 0 && (
                                                        <div className="">
                                                            {
                                                                genreList.filter(
                                                                    (g: any) => g.id === item.subgenre_id
                                                                )[0]?.title
                                                            }
                                                        </div>
                                                    )}
                                            </div>
                                        </td>
                                        <td style={{ minWidth: '170px' }}>
                                            <div className="cell-content">
                                                {item.fp_rel?.moods?.length > 1 && (
                                                    item.fp_rel.moods?.map((m: any, midx: number) => m !== '' && (
                                                        <div className="d-flex" key={midx}>
                                                            <div className="percent">{
                                                                Math.round((item.fp_rel.real_moods.match(new RegExp(`,${m},`, 'g')) || []).length * 100 / (item.fp_rel.real_moods.split(',').length - 2)) + "%"
                                                            }
                                                            </div>
                                                            {moodList.filter(
                                                                (g: any) => g.id === Number(m)
                                                            )[0]?.title}

                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        </td>
                                        <td className="actions" style={{ minWidth: '132px' }}>
                                            <div className="cell-content">
                                                <div className="d-flex">
                                                    {user?.profile.membership_level > 1 && (<img className="focus" src="/imgs/track_plus.svg" alt="add" onClick={() => onClickPlus(item)} />)}
                                                    {(true || item.user_id === user.id) && (<img className="focus" src="/imgs/track_edit.svg" alt="edit" onClick={() => onClickEdit(item)} />)}
                                                    <img className={"focus " + (fileExist[index] === 1 ? "" : "d-none")} src="/imgs/track_analyze.svg" alt="analyze"
                                                        onClick={() => handleTrackDetail(item)}
                                                    />
                                                    <img className={"focus " + (fileExist[index] === 1 ? "" : "d-none")} src={`/imgs/track_${playing === index ? "pause" : "play"}.svg`} alt="play"
                                                        onClick={() => {
                                                            let url = `https://prelistening.cugate.com/?i=${item.file_info.id}`;
                                                            let aud = new Audio(url);
                                                            if (playing === index) {
                                                                aud.pause();
                                                                setPlaying(-1);
                                                            } else {
                                                                setAudio(aud);
                                                                aud.play();
                                                                setPlaying(index);
                                                            }

                                                        }}
                                                    />
                                                    {item.user_id === user.id && (<img className="focus" src="/imgs/track_delete.svg" alt="delete" />)}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}

                    </tbody>
                </table>
            </div>
            <Pagination
                pagination={trackSearch.pagination}
                handlePage={handlePage}
            />
        </>
    )
}

export default TrackTable;